var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1301_24984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 2H6C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.52 11.7799C16.53 11.7199 16.54 11.6599 16.54 11.5899C16.54 11.5299 16.54 11.4699 16.52 11.3999C16.51 11.3399 16.49 11.2799 16.47 11.2199C16.45 11.1599 16.41 11.0999 16.37 11.0399C16.35 11.0099 16.34 10.9699 16.32 10.9399C16.3 10.9199 16.27 10.9099 16.25 10.8799C16.23 10.8599 16.22 10.8299 16.19 10.8099L10.44 5.99995C10.02 5.64995 9.38997 5.69995 9.02997 6.12995C8.67997 6.54995 8.72997 7.17994 9.15997 7.53995L14 11.5799L9.15997 15.6199C8.73997 15.9699 8.67997 16.6099 9.02997 17.0299C9.22997 17.2699 9.50997 17.3899 9.79997 17.3899C10.03 17.3899 10.25 17.3099 10.44 17.1599L16.19 12.3499C16.19 12.3499 16.23 12.2999 16.25 12.2699C16.27 12.2499 16.3 12.2399 16.31 12.2199C16.33 12.1899 16.34 12.1499 16.36 12.1199C16.4 12.0599 16.43 12.0099 16.46 11.9399C16.48 11.8799 16.5 11.8199 16.51 11.7599L16.52 11.7799Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1301_24984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand-icon.22e5ffee2427b6142bbcfb41385064e5.svg";
export { ForwardRef as ReactComponent };